var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticStyle:{"padding":"0px 20px"}},[_c('v-col',{attrs:{"cols":"4"}},[_c('v-select',{attrs:{"label":"Adjuntar Contrato","items":_vm.contratoAdjuntoList},on:{"change":_vm.avisarCambio},model:{value:(_vm.contratoAdjunto),callback:function ($$v) {_vm.contratoAdjunto=$$v},expression:"contratoAdjunto"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }